import usePhoto from "../../hooks/use-photo";
import { classnames } from "../../utils/index.jsx";
import Img from "./Img";

export default function Photo({
  photoId,
  type = "photo",
  isThumbnail = false,
  cover = false,
  alt,
  className,
  onDelete,
  style,
}) {
  const { photo } = usePhoto(photoId, isThumbnail, type);

  return (
    <Img
      alt={alt}
      className={classnames(className)}
      blob={photo}
      onDelete={onDelete}
      cover={cover || isThumbnail}
      style={style}
    />
  );
}
